<template>
  <div class="fee-waived-banner" :class="levelModifier">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" rx="9" fill="currentColor" />
      <path
        d="M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
    <span v-html="text"></span>
  </div>
</template>

<script src="./fee-waived-banner.js"></script>
<style src="./fee-waived-banner.scss" lang="scss"></style>
